import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {getImageUrl} from '../../../helpers/image';

import {ONBOARDING_CLOSE_TIMEOUT} from './constants';

const OPENED_ANIMATION_STATE = 'opened';
const PULSE_ANIMATION_STATE = 'pulse';
const CLOSED_ANIMATION_STATE = 'closed';

import styles from './article-reactions-onboarding.module.css';

const ArticleReactionOnboarding = ({textVariant, onClose, onRemoveOnboarding}) => {
  const [animationState, setAnimationState] = useState(OPENED_ANIMATION_STATE);
  const {t} = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState(CLOSED_ANIMATION_STATE);
    }, ONBOARDING_CLOSE_TIMEOUT);

    return (() => {
      clearTimeout(timer);
    });
  }, []);

  const onCloseIconClick = () => {
    onClose();
    setAnimationState(CLOSED_ANIMATION_STATE);
  };

  const onAnimationEndHandler = () => {
    switch (animationState) {
      case OPENED_ANIMATION_STATE:
        setAnimationState(PULSE_ANIMATION_STATE);
        break;
      case CLOSED_ANIMATION_STATE:
        onRemoveOnboarding();
        break;
      default:
        setAnimationState(PULSE_ANIMATION_STATE);
    }
  };

  return (
    <div className={styles.staticContainer}>
      <div
        className={clsx(styles.container, {
          [styles.pulse]: animationState === PULSE_ANIMATION_STATE,
          [styles.open]: animationState === OPENED_ANIMATION_STATE,
          [styles.closed]: animationState === CLOSED_ANIMATION_STATE
        })}
        onAnimationEnd={onAnimationEndHandler}
      >
        <Typography variant="title-14">
          {t(`articleReactions.onboarding.${textVariant}`)}
          <img
            src={getImageUrl('/icons/close-burger.svg')}
            className={styles.closeIcon}
            alt="close"
            onClick={onCloseIconClick}
          />
        </Typography>
      </div>
    </div>
  );
};

export {ArticleReactionOnboarding};
